import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import SvgIcon from './SvgIcon';

const RoundSvgIcon = ({ circle, children, ...props }) => (
  <SvgIcon size="large" {...props}>
    {circle && <circle cx="12" cy="12" r="12" fill={props.color} />}
    {children}
  </SvgIcon>
);

RoundSvgIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  circle: PropTypes.bool,
};

export default pure(RoundSvgIcon);
